// The favourites list names its columns backwards. This puts them right.
//
// ⚠️ ONE ENDPOINT, ONE QUIRK, AND IT IS NOT A GUESS. Probed against the live
// server on 2026-08-09 (GetListoffavouriteDevicesbyUserId, UserId 1):
//
//     DeviceName          ActualDeviceName
//     "4 Touch Switch"    "Door switch"
//     "Ac Touch Switch"   "ac"
//     "Fan Touch Switch"  "Fan touch switch"
//     "Door Lock"         "MAIN DOOR LOCK"
//     "4 Touch Switch"    "4 TOUCH"
//
// `DeviceName` there is the PRODUCT TYPE from the DeviceType table, and
// `ActualDeviceName` is what the customer named the device. Every other reply in
// this API — room list, location list, common devices, device detail — uses
// `DeviceName` for the customer's name.
//
// So a card reading `DeviceName`, which is every card, showed the favourites
// screen as "4 Touch Switch / 4 Touch Switch / Ac Touch Switch" — the same three
// product names repeated — where the room screen showed "Door switch", "Bed
// switch", "WASHROOM". The devices are indistinguishable precisely where the
// user has chosen to collect the ones they care about.
//
// Normalised in core so both shells get it and no card has to know which query
// its row came from.

/** True when the row carries a name of its own. */
const ownNameOf = (d) => String((d && d.ActualDeviceName) ?? '').trim();

/**
 * One favourites row, with the two name columns put back the right way round.
 *
 * A row with no `ActualDeviceName` is returned untouched: a device the customer
 * never renamed is better shown as its product type than as an empty label.
 */
export function fixFavouriteRow(d) {
  const own = ownNameOf(d);
  if (!own) return d;
  return {
    ...d,
    DeviceName: own,
    // The product type keeps the field every other reply uses for it, so
    // anything that wants to show "4 Touch Switch" still can.
    DeviceTypeName: d.DeviceTypeName ?? d.DeviceName,
  };
}

/** The whole list. Non-arrays pass through, so a failed read stays a failed read. */
export function fixFavouriteNames(rows) {
  return Array.isArray(rows) ? rows.map(fixFavouriteRow) : rows;
}

export default fixFavouriteNames;
